import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './PrintPage.css';

const PrintPage = () => {
  const [menu, setMenu] = useState([]);
  const [isNextWeek, setIsNextWeek] = useState(false); // State to track current/next week
  const navigate = useNavigate(); // Hook for navigation

  useEffect(() => {
    fetchMenu();
  }, [isNextWeek]); // Re-fetch the menu when the week changes

  const fetchMenu = async () => {
    const menuUrl = isNextWeek ? '/menu1.php' : '/menu.php'; // Load menu1.php for next week
    try {
      const response = await fetch(menuUrl); // Načítání dat z PHP skriptu
      const data = await response.json();
      setMenu(data); // Nastavení načteného menu do stavu
    } catch (error) {
      console.error('Chyba při načítání menu:', error);
    }
  };

  const getCurrentWeekDates = () => {
    const current = new Date();
    const first = current.getDate() - current.getDay() + 1 + (isNextWeek ? 7 : 0); // První den je pondělí, přidat 7 pokud je následující týden
    const last = first + 4; // Poslední den je pátek

    const firstDay = new Date(current.setDate(first)).toLocaleDateString('cs-CZ');
    const lastDay = new Date(current.setDate(last)).toLocaleDateString('cs-CZ');

    return `${firstDay} - ${lastDay}`;
  };

  const handlePrint = () => {
    window.print();
  };

  const handleBack = () => {
    navigate('/edit-menu'); // Navigate back to the editable menu
  };

  return (
    <div className="print-container">
      {/* Buttons to switch between weeks */}
      <div className="week-switcher mb-4">
        <button
          className={`mr-2 ${!isNextWeek ? 'bg-blue-500' : 'bg-gray-500'} text-white py-2 px-4 rounded`}
          onClick={() => setIsNextWeek(false)}
        >
          Aktuální týden
        </button>
        <button
          className={`${isNextWeek ? 'bg-blue-500' : 'bg-gray-500'} text-white py-2 px-4 rounded`}
          onClick={() => setIsNextWeek(true)}
        >
          Následující týden
        </button>
      </div>

      {/* Tlačítko pro tisk a tlačítko zpět */}
      <div className="button-container">
        <button onClick={handleBack} className="back-button">
          Zpět
        </button>
        <button onClick={handlePrint} className="print-button">
          Tisknout
        </button>
      </div>

      {/* Tento div bude tisknutelný */}
      <div className="printable-area">
        <main className="bran-content flex flex-col">
          <div className="bran-weekly-menu-header">
            <h2 className="menu-title">Polední menu pro týden {getCurrentWeekDates()}</h2>
            <div className="bran-weekly-menu-content">
              {menu.length > 0 ? (
                menu.map((item, index) => (
                  <div key={index} className="menu-item">
                    {item.header ? (
                      <h3 className='mensi'>{item.name}</h3>
                    ) : (
                      <ul>
                        <li>
                          <span>{item.name}</span>
                        </li>
                      </ul>
                    )}
                  </div>
                ))
              ) : (
                <p>Menu zatím není k dispozici.</p>
              )}
            </div>
          </div>

          {/* Malý div pro přidání vlastních vět */}
          <div className="custom-text">
            <p>Polévka 35,- Jídlo 115,- Menu 125,- </p>
            <p>Cena menu do vlastních nádob 105,-</p>
            <p>Po-Pá 10:00 - 13:30 objednávky na tel. <strong>730 899 466</strong></p><br/>
            <p>Zajišťujeme rozvoz obědů po Chotěšově a blízkém okolí</p>
            <p>www.pizzapointwest.cz</p>
          </div>
        </main>
      </div>
    </div>
  );
};

export default PrintPage;